import {
  BRAND_BILLING_QUERY_KEY,
  ORGANISATION_LIST_QUERY_KEY,
} from "@entities/organisation/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBrandBilling } from "@shared/lib/types/brandBilling";
import { BILLING_BRAND_LIST_QUERY_KEY } from "../constants";
import { CampaignService } from "../services/BillingBrand.service";

interface CreateBrandBillingParams {
  brandBilling: Partial<IBrandBilling>;
}

export function useCreateBrandBilling(brandOrganisationId?: string) {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
    error,
  } = useMutation<CreateBrandBillingParams>({
    mutationFn: async ({ brandBilling }) => {
      try {
        return await CampaignService.createBrandBilling(brandBilling);
      } catch (err: any) {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }
    },
    options: {
      queryKey: BILLING_BRAND_LIST_QUERY_KEY,
    },
    onSuccess: (c, _, params) => {
      c.invalidateQueries({ queryKey: BILLING_BRAND_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...BRAND_BILLING_QUERY_KEY, params?.brandBilling?.brandId],
      });
      if (brandOrganisationId) {
        c.invalidateQueries({
          queryKey: [...ORGANISATION_LIST_QUERY_KEY, brandOrganisationId],
        });
      }
    },
  });

  return {
    create,
    isCreating,
    isCreated,
    error,
  };
}
